import { useAuth0 } from "@auth0/auth0-react";
import { useQuery } from "@tanstack/react-query";
import { QueryKeys } from "../utils";
import request from "@/lib/api/handler";

export interface CandidateResource {
  id: string;
  headline: string;
  summary: string;
  image: string;
  link: string;
}

export const useCandidateResourcesQuery = () => {
  const { getAccessTokenSilently } = useAuth0();

  const { isLoading, data, error } = useQuery({
    queryKey: QueryKeys.candidateResources,
    staleTime: Infinity,
    refetchOnWindowFocus: false,
    queryFn: async () => {
      const token = await getAccessTokenSilently();
      const resp = await request<CandidateResource[]>({
        method: "GET",
        path: "/api/resource/candidate",
        token,
      });

      return resp.slice(-6);
    },
  });

  return {
    candidateResourcesLoading: isLoading,
    candidateResources: data ?? null,
    candidateResourcesError: error ?? null,
  };
};
